

var Project = {

	settings: {
		menu: {
			animationDuration: 500
		},
		dropdown: {
			animationDuration: 250
		},
		accordion: {
			animationDuration: 250
		},
		upload: {
			acceptFileTypes: /(\.|\/)(gif|jpe?g|png|pdf)$/i,
			acceptedSize: 2 * 1024 * 1024
		}
	},

	init: function () {
		Project.mobileMenu();
		Project.formElements();
		Project.dropdowns();
		Project.accordion();
		Project.tableFilters();
		Project.tableCheckboxes();
		Project.validation();
		Project.graphs();
		Project.checkoutSummary();
	},

	mobileMenu: function () {
		$('.menu-trigger').on('click', function (e) {
			e.preventDefault();
			$('.menu').slideToggle(Project.settings.menu.animationDuration, function () {
				if ($(this).is(':hidden')) $(this).css({ display: '' });
			});
		});
	},

	formElements: function () {
		// $('select').selectmenu({
		// 	create: function(){
		// 		var $select = $(this);
		// 		var $button = $select.selectmenu('widget');
		// 		$button
		// 			.addClass($(this).attr('class'))
		// 			.toggleClass('placeholder', $select.val() === null);
		// 	},
		// 	change: function(e){
		// 		var $select = $(this);
		// 		var $button = $select.selectmenu('widget');
		// 		$button.toggleClass('placeholder', $(this).val() === null);
		// 	},
		// 	open: function(e){
		// 		var $select = $(this);
		// 		var $button = $select.selectmenu('widget');
		// 		var $menu = $select.selectmenu('menuWidget');

		// 		$menu.closest('.ui-selectmenu-menu').width($button.outerWidth()-2);
		// 	}
		// });

		//$( 'input[type="radio"], input[type="checkbox"]' ).checkboxradio();

		$.datepicker.setDefaults($.datepicker.regional['pl']);

		$('.datepicker').datepicker({
			dateFormat: "dd.mm.yy"
		}).on('change', function () {
			$(this).toggleClass('empty', !$(this).val().length);
			$(this).datepicker('setDate', $(this).val());
			$(this).blur();

			var $minDateTarget = $($(this).attr('data-mindatefor'));
			var $maxDateTarget = $($(this).attr('data-maxdatefor'));

			if ($minDateTarget.length) {
				$minDateTarget.datepicker('option', 'minDate', $(this).val());
			}
			if ($maxDateTarget.length) {
				$maxDateTarget.datepicker('option', 'maxDate', $(this).val());
			}
		}).trigger('change');

		$('.file-upload').each(function () {
			var $wrapper = $(this);
			var $input = $wrapper.find('input.fileupload');
			var $fileList = $wrapper.find('.file-list');

			$input.fileupload({
				//forceIframeTransport: true,
				limitMultiFileUploads: 10,
				limitConcurrentUploads: 3,
				maxNumberOfFiles: 10,
				// maxFileSize: Project.settings.upload.acceptedSize,
				// acceptFileTypes: Project.settings.upload.acceptFileTypes,
				//url: 'upload/server/php/index.php',
				url: 'http://localhost:8000/conversations/file/upload',
				dataType: 'json',
				xhrFields: {
					withCredentials: true
				},
				add: function (e, data) {
					var uploadErrors = [];
					data.context = $('<div/>').appendTo($fileList);

					if (data.originalFiles[0].type.length && !Project.settings.upload.acceptFileTypes.test(data.originalFiles[0].type)) {
						uploadErrors.push('Not an accepted file type. ');
					}
					if (data.originalFiles[0].size !== undefined && data.originalFiles[0].size > Project.settings.upload.acceptedSize) {
						uploadErrors.push('Filesize is too big. ');
					}


					if (uploadErrors.length > 0) {
						$('<a href="#" class="remove" />').appendTo(data.context);
						$('<div class="error"/>').text(data.files[0].name).appendTo(data.context);
						$.each(uploadErrors, function () {
							$('<span class="error"/>').text(this).appendTo(data.context);
						});
					}
					else {
						$.each(data.files, function (index, file) {
							$('<a href="#" class="remove" />').appendTo(data.context);
							$('<p class="uploading" />').text(file.name).appendTo(data.context);
						});
						$wrapper.closest('form').find('[type="submit"]').prop('disabled', true);
						data.submit();
					}

					$wrapper.toggleClass('active', $fileList.children().length);

					$(data.context).find('a.remove').on('click', function (e) {
						e.preventDefault();
						data.abort();
						data.context.remove();
						$wrapper.toggleClass('active', $fileList.children().length);
					});
				},
				done: function (e, data) {
					$wrapper.closest('form').find('[type="submit"]').prop('disabled', false);

					$(data.context).find('p.uploading').removeClass('uploading');

					$.each(data.result.files, function (index, file) {
						$(data.context).append('<input type="hidden" name="upload[]" value="' + file.url + '" />');
					});

					$(data.context).find('a.remove').off('click').on('click', function (e) {
						e.preventDefault();
						data.context.remove();
						$wrapper.toggleClass('active', $fileList.children().length);
						if (data.result.files.length && data.result.files[0].deleteUrl) {
							$.ajax({
								dataType: 'json',
								url: data.result.files[0].deleteUrl,
								type: data.result.files[0].deleteType
							});
						}
					});
				}
			});
		});
	},

	dropdowns: function () {
		// $('header').on('click', '.dropdown .trigger', function(e){
		$('.dropdown .trigger').unbind('click');
		$('body').on('click', '.dropdown .trigger', function (e) {
			// $('.dropdown .trigger').click(function (e){
			// console.log('dropdown');

			e.preventDefault();
			var $dropdown = $(this).closest('.dropdown');
			if (!$dropdown.find('.dropdown-menu').is(':animated')) {
				if (!$dropdown.hasClass('active')) {
					$dropdown.addClass('active');
					$dropdown.find('.dropdown-menu').stop(1, 0).slideDown(Project.settings.dropdown.animationDuration);
				}
				else {
					$dropdown.find('.dropdown-menu').slideUp(Project.settings.dropdown.animationDuration, function () {
						$dropdown.removeClass('active');
					});
				}
			}
		});
	},

	accordion: function () {
		// $('.accordion, .menu').each(function(){
		// 	var $acc = $(this);

		// 	$acc.find('.trigger').each(function(i){
		// 		if(!$(this).is('[data-id]') && $(this).nextAll('.content').length === 0) $(this).next().addClass('content');

		// 		$(this).nextAll('.content:not([data-id])').first().add(this).attr('data-id', i+1);
		// 	});


		// });

		// $('body').on('click', '.trigger', function(e, params){
		// 	e.preventDefault();

		// 	var $content = $(this).closest('.accordion, .menu').find('.content[data-id="'+$(this).attr('data-id')+'"]');
		// 	var duration = Project.settings.accordion.animationDuration;

		// 	if($content.is(':animated')) return;
		// 	if(params && params.duration !== undefined) duration = params.duration;

		// 	$(this).add($content).toggleClass('active', !$content.hasClass('active'));
		// 	$content.slideToggle(duration);

		// 	if(!params || params.closeOthers) $(this).closest('.accordion').find('.trigger.active').not('[data-id="'+$(this).attr('data-id')+'"]').trigger('click', {closeOthers: false});
		// });

		// $('.trigger.active').trigger('click', {duration: 0});
	},

	menu: function () {
		$('.accordion .trigger, .sidebar .trigger').unbind('click');
		$('.accordion .trigger, .sidebar .trigger').click(function (e) {
			e.preventDefault();
			if ($(this).next().is('ul') || $(this).next().hasClass('content')) {
				var ul = $(this).next();
				if (ul.is(":visible")) {
					$(this).next().hide(500);
				} else {
					$(this).next().show(500);
				}
			}
		});
	},

	validation: function () {
		var emailRegex = /^[A-Z0-9._%+\-]+@[A-Z0-9.\-]+\.[A-Z]+$/i;

		var markError = function (elems, test) {
			if (test) {
				$(elems).each(function (i, elem) {
					$(elem).removeClass('error');
					$(elem).closest('label').removeClass('error');
					$(elem).siblings('[id="' + $(elem).attr('id') + '-button"]').removeClass('error');
					if ($(elem).prop('id')) $('label[for="' + $(elem).prop('id') + '"]').removeClass('error');
				});
			}
			else {
				$(elems).each(function (i, elem) {
					$(elem).addClass('error');
					$(elem).closest('label').addClass('error');
					$(elem).siblings('[id="' + $(elem).attr('id') + '-button"]').addClass('error');
					if ($(elem).prop('id')) $('label[for="' + $(elem).prop('id') + '"]').addClass('error');
				});
			}
		};

		$('form.validate').each(function (i, form) {
			$('input.required, textarea.required', form).on('validate', function () {
				markError(this, $(this).val().length);
			});

			$('select.required', form).on('validate', function () {
				markError(this, $(this).val() !== '');
			});

			$('input.required[type="email"]', form).off('validate').on('validate', function () {
				markError(this, emailRegex.test($(this).val()));
			});

			$('.required[data-confirm]', form).off('validate').on('validate', function () {
				var target = $($(this).attr('data-confirm'));
				markError(this, target.length && $(this).val().length && $(this).val() == target.val());
			});

			$('input.required[type="checkbox"], input.required[type="radio"]', form).off('validate').on('validate', function () {
				markError(this, $(this).prop('checked'));
			});

			$('input.required-any[type="checkbox"], input.required-any[type="radio"]', form).off('validate').on('validate', function () {
				var sameName = $('input[name="' + $(this).attr('name') + '"]');
				markError(sameName, sameName.filter(':checked').length);
			});

			$('input, textarea, select', form).on('change blur selectmenuchange', function () {
				if ($(this).is('[type=radio]') && $(this).prop('name')) {
					$('input[name="' + $(this).prop('name') + '"]', form).trigger('validate');
				}
				else {
					$(this).trigger('validate');
				}
			});

			$(form).on('submit', function (e) {
				// console.log('submit');
				$('input, select, textarea', this).trigger('validate');
				if ($('.error', this).length) {
					e.preventDefault();
				}
				else {
					e.preventDefault();
					// delete the line above to allow for default form submit
					// or add ajax submit (or other action) here
					alert('no errors - form would be submitted');
				}
			});
		});
	},

	tableCheckboxes: function () {
		// $('table').each(function(){
		// 	var $table = $(this);
		// 	var $thead = $table.children('thead');
		// 	var $tbody = $table.children('tbody');

		// 	$tbody.find('input[type="checkbox"]').on('change', function(){
		// 		var $all = $tbody.find('input[type="checkbox"]');
		// 		var $checked = $all.filter(':checked');
		// 		$thead.find('.select-all[type="checkbox"]').prop('checked', $all.length == $checked.length).checkboxradio('refresh');
		// 	}).first().trigger('change');

		// 	$thead.find('.select-all[type="checkbox"]').on('change', function(){
		// 		$tbody.find('input[type="checkbox"]').prop('checked', $(this).prop('checked')).checkboxradio('refresh');
		// 	});
		// });
	},

	tableFilters: function () {
		$('.filters').each(function () {
			var $filtersRoot = $(this);
			var $bulkActions = $filtersRoot.find('.bulk-actions');
			var $filterGroupChoosers = $filtersRoot.find('[data-filter-group-select]');
			var $filterGroups = $filtersRoot.find('[data-filter-group]');
			var $table = $($filtersRoot.attr('data-table'));
			var $thead = $table.children('thead');
			var $tbody = $table.children('tbody');

			if ($table.length == 0) return;

			$table.data('filters', $filtersRoot);

			var $filterTriggers = $filtersRoot.find('[data-filter-trigger], [data-filter]');

			var filterTimer;

			$filterTriggers.filter('a, button, .btn').on('click', function () {
				if (filterTimer) clearTimeout(filterTimer);
				filterTimer = setTimeout(function () {
					Project.tableFiltersUpdate($table);
				}, 50); // tiny delay to allow time for multiple filters to be changed before filtering
			});

			$filterTriggers.not('a, button, .btn').on('change selectmenuchange search', function () {
				if (filterTimer) clearTimeout(filterTimer);
				filterTimer = setTimeout(function () {
					Project.tableFiltersUpdate($table);
				}, 50); // tiny delay to allow time for multiple filters to be changed before filtering
			});

			$filterTriggers.filter('[type="text"], [type="search"]').on('keyup', function () {
				if (filterTimer) clearTimeout(filterTimer);
				filterTimer = setTimeout(function () {
					Project.tableFiltersUpdate($table);
				}, 500);
			});

			$tbody.find('input[type="checkbox"]').on('change', function () {
				var $all = $tbody.find('input[type="checkbox"]:checked');
				var $checked = $all.filter(':checked');
				$bulkActions.toggleClass('disabled', $checked.length);
			}).first().trigger('change');

			$thead.find('.select-all[type="checkbox"]').on('change', function () {
				$bulkActions.toggleClass('disabled', !$(this).prop('checked'));
			});

			$filterGroupChoosers.on('change selectmenuchange', function () {
				var chosen = $(this).val();
				var $options = $(this).children('option');
				$options.each(function () {
					$filterGroups.filter('[data-filter-group="' + $(this).attr('value') + '"]').toggleClass('active', chosen === $(this).attr('value'));
				});
				Project.tableFiltersUpdate($table);
			}).trigger('change');
		});
	},

	tableFiltersUpdate: function ($tables) {
		var childTables = $('tr.children table');
		if (!$tables || $tables.length == 0) $tables = $('.table').not(childTables);

		$tables.each(function () {
			var $table = $(this);
			var $filtersRoot = $table.data('filters');

			if ($filtersRoot.length == 0) return;

			var $thead = $table.children('thead');
			var $headers = $thead.find('th');
			var $tbody = $table.children('tbody');
			var $rowsAll = $tbody.children('tr');
			var $rows = $tbody.children('tr').not('.children');
			var $filters = $filtersRoot.find('[data-filter]').not('.clone *');
			var dateConditions = {};
			var searchConditions = {};
			var disableFilters = true;

			$filters.each(function () {
				var $filter = $(this);
				var $group = $filter.closest('[data-filter-group]');

				if ($group.length && !$group.is('.active')) return true;

				if ($filter.is('[type="checkbox"],[type="radio"]') && $filter.prop('checked') == false) return true;

				var filterType = $filter.first().attr('data-filter-type');
				var filterColumns = $filter.first().attr('data-filter-columns');
				var filterGroup = $filter.first().attr('data-filter');

				if (filterType == undefined) filterType = $filter.closest('[data-filter-type]').attr('data-filter-type');
				if (filterColumns == undefined) filterColumns = $filter.closest('[data-filter-columns]').attr('data-filter-columns');
				if (filterGroup == '') filterGroup = 'all';

				if (filterType == undefined) filterType = 'string';
				if (filterColumns == undefined) filterColumns = 'all';

				var searchVal = $filter.val();
				searchVal = searchVal.replace(/(^\s+|\s+$)/ig, '').replace(/\s+/ig, ' ');

				if (searchVal.length > 0) {
					switch (filterType) {
						case 'min-date':
						case 'max-date':
							searchVal = {
								date: $.datepicker.parseDate($filter.data('datepicker').settings.dateFormat, searchVal),
								format: $filter.data('datepicker').settings.dateFormat
							}
							break;
						case 'any-word':
							searchVal = searchVal.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
							searchVal = '(?=(?:.*(' + searchVal.split(' ').join('|') + ')))';
							break;
						case 'all-words':
							searchVal = searchVal.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
							searchVal = '(?=(?:.*' + searchVal.split(' ').join('))(?=(?:.*') + '))';
							break;
						default:
						case 'string':
							searchVal = searchVal.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
							searchVal = '(?=(?:.*' + searchVal + '))';
							break;
					}

					$.each(filterColumns.split(','), function (i, column) {
						if (filterType == 'min-date' || filterType == 'max-date') {
							if (dateConditions[column] == undefined) dateConditions[column] = {};
							if (dateConditions[column][filterType] == undefined) dateConditions[column][filterType] = [];
							dateConditions[column][filterType].push(searchVal);
						}
						else {
							if (searchConditions[filterGroup] == undefined) searchConditions[filterGroup] = {};
							if (searchConditions[filterGroup][column] == undefined) searchConditions[filterGroup][column] = [];
							searchConditions[filterGroup][column].push(searchVal);
						}
						disableFilters = false;
					});
				}
			});

			$rowsAll.removeClass('filtered-out filtered-in');

			if (disableFilters) {
				$rowsAll.show();
			}
			else {
				$.each(searchConditions, function (filterGroup, searchCond) {
					$.each(searchCond, function (column, regexp) {
						regexp = new RegExp('^(' + regexp.join('|') + ')', 'im');
						if (column == 'all') {
							$rows.not('.filtered-out').each(function () {
								var $row = $(this);
								if (regexp.test($row.text())) $row.addClass('filtered-in');
							});
						}
						else {
							if (!(column > -1)) {
								column = $headers.index($headers.filter(column));
							}
							if (!(column > -1)) return;

							$rows.not('.filtered-out').each(function () {
								var $row = $(this);
								if (regexp.test($row.children('td').eq(column).text())) $row.addClass('filtered-in');
							});
						}
					});
					$rows.not('.filtered-in').addClass('filtered-out');
					$rows.filter('.filtered-in').removeClass('filtered-in');
				});

				if (!$.isEmptyObject(dateConditions)) {
					$rows.not('.filtered-out').each(function () {
						var $row = $(this);
						$row.addClass('filtered-out');

						$.each(dateConditions, function (column, searchCond) {
							var $cell = $row.children('td').eq(column);
							var matches = false;
							$.each(searchCond, function (filterType, conds) {
								$.each(conds, function (i, cond) {
									if (!$cell.data('parsedDate')) $cell.data('parsedDate', {});
									if (!$cell.data('parsedDate')[cond.format]) $cell.data('parsedDate')[cond.format] = $.datepicker.parseDate(cond.format, $cell.text());

									if (filterType == 'min-date' && $cell.data('parsedDate')[cond.format] < cond.date) {
										$cell.addClass('filtered-out');
										return false;
									}
									else if (filterType == 'max-date' && $cell.data('parsedDate')[cond.format] > cond.date) {
										$cell.addClass('filtered-out');
										return false;
									}
								});

								if ($cell.hasClass('filtered-out')) {
									return false;
								}
							});

							if (!$cell.hasClass('filtered-out')) {
								$row.removeClass('filtered-out');
								return false;
							}
							else {
								$cell.removeClass('filtered-out');
							}
						});
					});
				}


				$rows.each(function () {
					if ($(this).hasClass('filtered-out')) $(this).hide();
					else $(this).show();

					if ($(this).hasClass('parent')) {
						$tbody.children('.children[data-bind="' + $(this).attr('data-bind') + '"]').toggleClass('filtered-out', $(this).hasClass('filtered-out'));
					}
				});
			}
		});
	},

	checkoutSummary: function () {
		var box = $('.checkout-summary');
		if (box.length) {
			var summaryPosition = $(box).offset().top - parseInt(box.css('top'));

			$(window).scroll(function () {
				var ios = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
				// console.log("O: " + parseInt(box.css('top')));
				// console.log("S: " + box.offset().top)

				if ($(window).scrollTop() > summaryPosition) {
					box.css({position: 'fixed'});
				} else {
					box.css({position: 'absolute'});
				}
				// if (box.length > 0 && !ios) {
				// 	box.removeClass('sticky');
				// 	box.removeClass('sticky-bottom');
				// 	if ($(window).scrollTop() >= box.offset().top) {
				// 		box.addClass('sticky');
				// 		box.removeClass('sticky-bottom');

				// 		if (($('.configuration-form').offset().top + $('.configuration-form').outerHeight()) <= box.offset().top + box.outerHeight()) {
				// 			box.addClass('sticky');
				// 			box.addClass('sticky-bottom');
				// 		}
				// 	} else {
				// 		box.removeClass('sticky');
				// 		box.removeClass('sticky-bottom');
				// 	}
				// } else {
				// 	box.removeClass('sticky');
				// 	box.removeClass('sticky-bottom');

				// }
			});
		}
		
	},

	graphs: function () {
		$('.graph').each(function () {
			var $wrap = $(this);
			var data = window[$wrap.attr('data-source')];
			var now = new Date();

			if (!data) return;

			var smooth = $wrap.hasClass('smooth');
			var gridlines = $wrap.hasClass('gridlines');
			var points = $wrap.hasClass('points');
			var pointsTargets = points || $wrap.hasClass('points-invisible');
			var units = $wrap.attr('data-units');
			units = units ? units : '%';
			var unitsTime = $wrap.attr('data-time-units');
			var timeIntervals = $wrap.attr('data-time-intervals');
			timeIntervals = timeIntervals ? timeIntervals : '1';

			var roundUp = function (value) {
				var digits = Math.ceil(Math.log10(Math.abs(value) + 1));
				var pow = Math.pow(10, digits - 1);
				return Math.round(value / pow) * pow;
			}

			// set the dimensions and margins of the graph
			var leftLabelPadding = 12;
			var margin = { top: 20, right: 20, bottom: 25, left: 40 };

			if (units != '%') {
				leftLabelPadding = 30;
				margin.left = 110;
			}

			var width = $wrap.width() - margin.left - margin.right;
			var height = $wrap.height() - margin.top - margin.bottom;

			if (isNaN(width)) return;

			// parse the date / time
			var parseTime = d3.timeParse("%Y-%m-%dT%H:%M%Z");
			var formatDate = d3.timeFormat("%d.%m");
			var formatTime = d3.timeFormat("%H:%M:%S");
			var formatValue = units == '%' ? d3.format(".0%") : function (d) { return d3.format(',')(d) + ' ' + units };

			// set the ranges
			var x = d3.scaleTime();
			var y = d3.scaleLinear();

			// define the area
			var area = d3.area()
			if (smooth) area.curve(d3.curveMonotoneX);
			area.x(function (d) { return x(d.time); })
				.y0(height)
				.y1(function (d) { return y(d.value); });

			// define the line
			var valueline = d3.line();
			if (smooth) valueline.curve(d3.curveMonotoneX);
			valueline.x(function (d) { return x(d.time); })
				.y(function (d) { return y(d.value); });

			data.forEach(function (d) {
				d.time = parseTime(d.time);
				d.value = +d.value;
			});

			var dateRange = d3.extent(data, function (d) { return d.time; });
			var dayCount = Math.abs(d3.timeDay.floor(dateRange[0]) - d3.timeDay.ceil(dateRange[1])) / 1000 / 60 / 60 / 24;

			if (!unitsTime) {
				unitsTime = dayCount > 1 ? 'date' : 'time';
			}
			if (unitsTime == 'date') dateRange.push(d3.timeDay.floor(dateRange[0]), d3.timeDay.ceil(dateRange[1]));
			else dateRange.push(d3.timeHour.floor(dateRange[0]), d3.timeHour.ceil(dateRange[1]));
			dateRange = d3.extent(dateRange);

			var svg = d3.select($wrap[0]).append("svg");

			svg = svg.append("g")
				.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

			var leftAxis = d3.axisLeft(y)
				.tickFormat(formatValue)
				.tickPadding(leftLabelPadding);
			if (units == '%') leftAxis.tickValues([0, 0.25, 0.5, 0.75, 1]);
			else {
				var topLabelValue = roundUp(Math.ceil(d3.max(data, function (d) { return d.value; })));
				leftAxis
					// .ticks(5)
					.tickValues(d3.range(0, topLabelValue + 0.1, topLabelValue / 5));
			}

			var bottomAxis = d3.axisBottom(x)
				.tickPadding(12);

			if (unitsTime == 'time') {
				bottomAxis
					.ticks(d3.timeHour.filter(function (d) {
						return Math.round(Math.abs(d - dateRange[1]) / 1000 / 60 / 60) % timeIntervals === 0;
					}))
					.tickFormat(d3.timeFormat("%H:%M"));
			}
			else if (unitsTime == 'h') {
				bottomAxis
					.ticks(d3.timeHour.filter(function (d) {
						return Math.round(Math.abs(d - dateRange[1]) / 1000 / 60 / 60) % timeIntervals === 0;
					}))
					.tickFormat(function (d) {
						var hours = Math.round((now - d) / 1000 / 60 / 60);
						return hours == 0 ? 'Now' : hours + 'h';
					})
			}
			else {
				bottomAxis
					.ticks(d3.timeDay.filter(function (d) {
						return Math.round(Math.abs(d - dateRange[1]) / 1000 / 60 / 60 / 24) % timeIntervals === 0;
					}))
					.tickFormat(d3.timeFormat("%d.%m"))
			}


			// scale the range of the data
			x.domain(dateRange);
			y.domain([0, Math.ceil(d3.max(data, function (d) { return d.value; }))]);


			// add the area
			svg.append("path")
				.attr("class", "area");

			// add the X Axis
			svg.append("g")
				.attr("class", "bottom axis");

			// add the Y Axis
			svg.append("g")
				.attr("class", "left axis");

			// add the valueline path.
			svg.append("path")
				.attr("class", "line");

			svg.append("polyline")
				.attr("class", "domain-area");

			if (points || pointsTargets) {
				var div = d3.select("body").append("div")
					.attr("class", "graph-tooltip")
					.style("opacity", 0);

				var dots = svg.selectAll("dot")
					.data(data);

				if (points) {
					dots.enter().append("circle")
						.attr("class", "dot")
						.attr("r", 2);
				}

				dots.enter().append("circle")
					.attr("class", "dot-target")
					.attr("r", 10)
					.on("mouseover", function (d) {
						div.transition()
							.duration(200)
							.style("opacity", .9);
						div.html('<span>' + formatDate(d.time) + '</span><span>' + formatTime(d.time) + '</span><span>' + formatValue(d.value) + '</span>')
							.style("left", $(d3.event.target).offset().left + "px")
							.style("top", $(d3.event.target).offset().top + "px");
					})
					.on("mouseout", function (d) {
						div.transition()
							.duration(500)
							.style("opacity", 0);
					});
			}

			var resize = function () {
				width = $wrap.width() - margin.left - margin.right;
				height = $wrap.height() - margin.top - margin.bottom;

				if (isNaN(width)) return;

				x.range([0, width]);
				y.range([height, 0]);

				bottomAxis.tickSize(gridlines ? -height : 0);
				leftAxis.tickSize(gridlines ? -width : 0);

				d3.select($wrap[0]).select('svg')
					.attr("width", width + margin.left + margin.right)
					.attr("height", height + margin.top + margin.bottom);

				d3.select($wrap[0]).select(".bottom.axis")
					.attr("transform", "translate(0," + height + ")")
					.call(bottomAxis);

				d3.select($wrap[0]).select(".left.axis")
					.call(leftAxis);

				d3.select($wrap[0]).select(".area")
					.data([data])
					.attr("d", area);

				d3.select($wrap[0]).select(".line")
					.data([data])
					.attr("d", valueline);

				d3.select($wrap[0]).select(".domain-area")
					.attr("points", "0.5,0.5 0.5," + (height + 0.5) + " " + (width + 0.5) + "," + (height + 0.5));

				if (points || pointsTargets) {
					dots.enter().selectAll("circle")
						.attr("cx", function (d) { return x(d.time); })
						.attr("cy", function (d) { return y(d.value); });
				}

				var ticks = $wrap.find('.bottom.axis > .tick');
				var nth = ':nth-last-child(' + (1 + Math.floor(1 / (width / ticks.length / 50))) + 'n +1)'
				//if (!points) console.log(nth);

				ticks.filter(nth).show();
				ticks.not(nth).hide();
			}

			$(window).on('resize', resize);

			resize();
		});
	}
};


	// setTimeout(function () {
	// 	console.log('RUN');
	// 	Project.init();

	// }, 4000);





//////////////////
// WEBPACK FOOTER
// ./src/assets/js/scripts.js
// module id = 123
// module chunks = 0